/////////////////////
// IMPORTS
/////////////////////
import moment from "moment-timezone";

export interface IUpdatedEventInfo {
  startDate: string;
  startTime: string;
  endTime: string;
  endDate: string;
  room: string | null;
}

// takes google's data-date: 20191031, 19730222, etc.
// and google's formatted times: 12:30pm, 12pm, 1:30am, 2am, etc.
// output is a moment date
export function convertDataDateTimeToMoment(date: string, time: string, _timeZone?: string) {
  const m = moment(date);

  // convert time
  const timeArray = time.split(":");
  const ampm = timeArray[1] && timeArray[1].substring(2, 4).toLowerCase();
  let hour = Number(timeArray[0]);
  if (ampm === "pm" && hour < 12) {
    hour = hour + 12;
  } else if (ampm === "am" && hour === 12) {
    hour = hour - 12;
  }
  const minute = Number((timeArray[1] && timeArray[1].substring(0, 2)) || 0);

  m.hour(hour).minute(minute);

  return m;
}

// takes a date
// output is formatted as 12:30pm, 12pm, 1:30am, 2am, etc.
export function constructDataTime(date: Date, showMinutes?: boolean) {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const mm = minutes !== 0 ? `:${minutes}` : (showMinutes && ":00") || "";
  const a = hours >= 12 ? "pm" : "am";

  const modHours = hours % 12;
  const h = modHours === 0 ? 12 : modHours;
  return h + mm + a;
}

// takes a date
// output is formatted as 20180109, 20181115
export function constructDataDate(date: Date) {
  const YYYY = date.getFullYear().toString();
  const month = date.getMonth() + 1; // stupid 0 indexed months...
  const MM = month < 10 ? `0${month}` : month.toString();
  const day = date.getDate();
  const DD = day < 10 ? `0${day}` : day.toString();
  return YYYY + MM + DD;
}
